// =========================================== 
// File: src/pages/user/userDashboard.js
// ===========================================

import { useUser } from '../../context/userContext';
import BalanceCard from '../../Component/user/balanceCard';
import WithdrawalHistory from '../../Component/user/withdrawalHistory';
import { FiRefreshCw } from 'react-icons/fi';
import Footer from '../../Component/Footer/Footer'; // Import your footer component

export default function UserDashboard() {
  const { user, loading, refreshData } = useUser();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={styles.container}>
        <header style={styles.header}>
          <h1 style={styles.title}>Dashboard</h1>
          <div style={styles.headerControls}>
            {user?.username && (
              <span style={styles.welcome}>Welcome, {user.username}</span>
            )}
            <button onClick={refreshData} style={styles.refreshButton}>
              <FiRefreshCw style={styles.refreshIcon} />
            </button>
          </div>
        </header>

        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.spinner}></div>
            <p style={styles.loadingText}>Loading your dashboard...</p>
          </div>
        ) : (
          <div style={styles.content}>
            {/* Top Section - Balance Card */}
            <div style={styles.topSection}>
              <BalanceCard />
            </div>
            
            {/* Bottom Section - Withdrawal History */}
            <div style={styles.bottomSection}>
              <WithdrawalHistory />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

const styles = {
  container: {
    padding: '16px',
    flex: 1,
    backgroundColor: '#f5f5f7',
    color: '#111827',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    marginBottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  headerControls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    margin: 0,
    color: '#000000'
  },
  welcome: {
    fontSize: '14px',
    color: '#666666'
  },
  refreshButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '6px',
    borderRadius: '50%',
    transition: 'all 0.2s',
    ':hover': {
      backgroundColor: '#e5e5e5'
    }
  },
  refreshIcon: {
    fontSize: '18px',
    color: '#666666'
  },
  content: {
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  topSection: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    padding: '20px'
  },
  bottomSection: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    padding: '20px'
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    maxWidth: '600px',
    margin: '0 auto'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid rgba(0,0,0,0.1)',
    borderTopColor: '#3b82f6',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '16px'
  },
  loadingText: {
    fontSize: '16px',
    color: '#6b7280',
    margin: 0
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
  },
  '@media (max-width: 480px)': {
    container: {
      padding: '12px'
    },
    topSection: {
      padding: '16px'
    },
    bottomSection: {
      padding: '16px'
    }
  }
};
